import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listItem: {
    marginBottom: theme.spacing(3),
  },
  bold: {
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: theme.typography.h1.fontWeight,
  },
  innerList: {
    marginLeft: theme.spacing(4),
    listStyleType: 'lower-latin',
  },
  innerListItem: {
    marginBottom: theme.spacing(1),
  },
  asLink: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
}));
